import { Link, useParams } from "react-router-dom";
import { newsById } from "../data/site";

export default function NewsDetail() {
  const { id } = useParams();
  const news = newsById[id];

  if (!news) {
    return (
      <div className="panel">
        <div className="container prose">
          <h2 className="small-title">未找到该新闻</h2>
          <Link to="/news" className="text-link">
            返回新闻列表
          </Link>
        </div>
      </div>
    );
  }

  return (
    <article className="news-detail">
      <div className={`news-hero tone-${news.tone}`}>
        <div className="container">
          <Link to="/news" className="text-link light">
            返回新闻动态
          </Link>
          <h1>{news.title}</h1>
          <p>
            <time>{news.date}</time>
            {news.source ? <span> · {news.source}</span> : null}
          </p>
        </div>
      </div>
      <div className="container prose detail-body">
        <p>{news.content}</p>
        <p>
          文趣互动（海南）科技有限责任公司作为成都文趣星球科技有限公司全资子公司，持续关注并参与文化元宇宙、数字文旅在海南自贸港的落地。更多产品与合作信息，欢迎通过官网「联系我们」与我们沟通。
        </p>
      </div>
    </article>
  );
}
